// frontend/src/pages/Privacy.tsx
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ObfuscatedEmail } from "@/components/ObfuscatedEmail";

export default function Privacy() {
  const { t, i18n } = useTranslation("privacy");

  useEffect(() => {
    document.title = `${t("title")} – ELANI Energy`;
  }, [i18n.language, t]);

  return (
    <main className="mx-auto max-w-4xl px-4 py-10 text-base leading-7 text-slate-800">
      <h1 className="text-3xl font-semibold text-slate-900">{t("title")}</h1>
      <p className="mt-1 text-slate-600">{t("effective_date")}</p>

      <p className="mt-8">{t("intro")}</p>

      <h2 className="mt-8 text-xl font-medium">{t("controller.heading")}</h2>
      <p className="mt-2">{t("controller.entity_line1")}</p>
      <p className="mt-1">{t("controller.entity_line2")}</p>
      <p className="mt-1">{t("controller.entity_line3")}</p>
      <p className="mt-1">{t("controller.entity_line4")}</p>
      <p className="mt-1">{t("controller.entity_line5")}</p>
      <p className="mt-2">
        {t("controller.contact_label")}{" "}
        <ObfuscatedEmail u="info" d="elani-energy.com" />
      </p>

      <h2 className="mt-8 text-xl font-medium">{t("scope.heading")}</h2>
      <p className="mt-2">{t("scope.body")}</p>

      <h2 className="mt-8 text-xl font-medium">{t("categories.heading")}</h2>
      <ul className="mt-2 list-disc pl-6 space-y-1">
        <li>{t("categories.items.account")}</li>
        <li>{t("categories.items.auth")}</li>
        <li>{t("categories.items.usage")}</li>
        <li>{t("categories.items.project")}</li>
        <li>{t("categories.items.support")}</li>
      </ul>

      <h2 className="mt-8 text-xl font-medium">{t("purposes.heading")}</h2>
      <ul className="mt-2 list-disc pl-6 space-y-1">
        <li>{t("purposes.items.service")}</li>
        <li>{t("purposes.items.security")}</li>
        <li>{t("purposes.items.analytics")}</li>
        <li>{t("purposes.items.legal")}</li>
        <li>{t("purposes.items.comms")}</li>
      </ul>

      <h2 className="mt-8 text-xl font-medium">{t("cookies.heading")}</h2>
      <p className="mt-2">{t("cookies.body")}</p>

      <h2 className="mt-8 text-xl font-medium">{t("processors.heading")}</h2>
      <p className="mt-2">{t("processors.intro")}</p>
      <ul className="mt-2 list-disc pl-6 space-y-1">
        <li>{t("processors.items.frontend")}</li>
        <li>{t("processors.items.backend")}</li>
        <li>{t("processors.items.email_hosting")}</li>
      </ul>
      <p className="mt-2">{t("processors.transfers")}</p>

      <h2 className="mt-8 text-xl font-medium">{t("retention.heading")}</h2>
      <ul className="mt-2 list-disc pl-6 space-y-1">
        <li>{t("retention.items.account")}</li>
        <li>{t("retention.items.project")}</li>
        <li>{t("retention.items.logs")}</li>
      </ul>

      <h2 className="mt-8 text-xl font-medium">{t("rights.heading")}</h2>
      <ul className="mt-2 list-disc pl-6 space-y-1">
        <li>{t("rights.items.std")}</li>
        <li>{t("rights.items.object")}</li>
        <li>{t("rights.items.withdraw")}</li>
        <li>{t("rights.items.complaint")}</li>
      </ul>
      <p className="mt-2">{t("rights.contact")}</p>

      <h2 className="mt-8 text-xl font-medium">{t("children.heading")}</h2>
      <p className="mt-2">{t("children.body")}</p>

      <h2 className="mt-8 text-xl font-medium">{t("changes.heading")}</h2>
      <p className="mt-2">{t("changes.body")}</p>
    </main>
  );
}